import React from 'react';
import { categoryConfig } from '../../data/speciesData';

const MigrationChips = ({ activeCategories, onCategoryClick }) => {
  const allCategoryKeys = Object.keys(categoryConfig);
  const isAllActive = activeCategories.length === allCategoryKeys.length;

  return (
    <div className="flex gap-1.5 flex-wrap">
      <button
        onClick={(e) => {
          if (!isAllActive) {
            onCategoryClick('all', e);
          }
        }}
        className={`px-2.5 py-1 text-[9px] font-bold rounded-full uppercase tracking-wider whitespace-nowrap cursor-pointer font-label transition-colors ${
          isAllActive
            ? 'bg-primary text-on-primary'
            : 'bg-surface-variant text-on-surface-variant hover:bg-white/10'
        }`}
      >
        All
      </button>
      {Object.entries(categoryConfig).map(([key, config]) => {
        const isActive = activeCategories.includes(key) && !isAllActive;
        return (
          <button
            key={key}
            onClick={(e) => onCategoryClick(key, e)}
            className={`px-2.5 py-1 text-[9px] font-medium rounded-full uppercase tracking-wider whitespace-nowrap cursor-pointer font-label transition-colors ${
              isActive
                ? 'bg-primary text-on-primary'
                : 'bg-surface-variant text-on-surface-variant hover:bg-white/10'
            }`}
          >
            {config.label}
          </button>
        );
      })}
    </div>
  );
};

export default MigrationChips;
